const getters = {
	addressInfo: (state) => state.mapData.addressInfo,
};
export default getters;
